import { useQuery } from '@tanstack/react-query';
import { getLeadPipeline } from '../api/leads';

export function useLeadPipeline(enabled = true) {
  return useQuery({
    queryKey: ['lead-pipeline'],
    queryFn: getLeadPipeline,
    staleTime: 5 * 60 * 1000,
    enabled,
  });
}
